import { SharedModule } from '@app/shared/shared.module';
import { NgModule } from '@angular/core';

// Roteamento
import { RelatoriosRoutingModule } from './relatorios.routing';

// Guardas
// import { AuthGuard } from '@app/guards/auth.guard';

// Componentes
import { RelatorioExtratoBancarioComponent } from '@app/pages/relatorios/extrato-bancario/extrato-bancario.component';
import { RelatorioFluxoDeCaixaDiarioComponent } from '@app/pages/relatorios/fluxo-de-caixa-diario/fluxo-de-caixa-diario.component';
import { RelatorioDRComponent } from '@app/pages/relatorios/dr/dr.component';
import { DrFilhoComponent } from 'app/pages/relatorios/dr/dr-filho/dr-filho.component';
import { RelatorioDRPorTipoComponent } from '@app/pages/relatorios/drportipo/drportipo.component';
import { RelatorioLogsComponent } from '@app/pages/relatorios/logs/logs.component';
import { RelatorioExtratoParticipanteComponent } from '@app/pages/relatorios/extrato-participante/extrato-participante.component';
import { RelatorioCustosProcessoComponent } from '@app/pages/relatorios/custos-processo/custos-processo.component';
import { RecebimentosAtrasadosComponent } from '@app/pages/relatorios/recebimentos-atrasados/recebimentos-atrasados.component';
import { RelatorioChequeComponent } from '@app/pages/relatorios/cheques/cheques.component';
import { RelatorioPrevisaoMovimentacaoComponent } from '@app/pages/relatorios/previsao-movimentacao/previsao-movimentacao.component';
import { RelatoriosMeAviseComponent } from '@app/pages/relatorios/me-avise/relatorio-me-avise.component';
import { RelatorioProtocolosDiariosComponent } from '@app/pages/relatorios/protocolos-diarios/protocolos-diarios.component';
import { ProtocolosTipoComponent } from '@app/pages/relatorios/protocolos-diarios/protocolos-tipo/protocolos-tipo.component';
import { MetaVisaoMensalComponent } from './meta-novos-processos/meta-visao-mensal/meta-visao-mensal.component';
import { MetaVisaoAnualComponent } from './meta-novos-processos/meta-visao-anual/meta-visao-anual.component';
import { MetaNovosProcessosComponent } from './meta-novos-processos/meta-novos-processos.component';
import { PublicacoesTipoComponent } from '@app/pages/relatorios/publicacoes-diarias/publicacoes-tipo/publicacoes-tipo.component';
import { RelatorioPublicacoesDiariasComponent } from '@app/pages/relatorios/publicacoes-diarias/publicacoes-diarias.component';

import { FaturamentoComponent } from '@app/pages/relatorios/faturamento/faturamento.component';
import { RelatoriosClientesComponent } from '@app/pages/relatorios/clientes/clientes.component';
import { ClientesPorAdvogadoComponent } from '@app/pages/relatorios/clientes/clientes-por-advogado/clientes-por-advogado.component';
import { ClientesSemMovimentacaoComponent } from '@app/pages/relatorios/clientes/clientes-sem-movimentacao/clientes-sem-movimentacao.component';
import { ClientesFiltrosComponent } from '@app/pages/relatorios/clientes/clientes-filtros/clientes-filtros.component';
import { RelatorioProcessosFiltradosComponent } from '@app/pages/relatorios/relatorio-processos-filtrados/relatorio-processos-filtrados.component';
// import { FiltradoPorUnidadeComponent } from '@app/pages/relatorios/relatorio-processos-filtrados/por-unidade/filtrado-por-unidade.component';
// import { FiltradoPorCidadeComponent } from '@app/pages/relatorios/relatorio-processos-filtrados/por-cidade/filtrado-por-cidade.component';
// import { FiltradoPorAreaDoProcessoComponent } from '@app/pages/relatorios/relatorio-processos-filtrados/por-area-do-processo/filtrado-por-area-do-processo.component';

import { FaturamentoRecebidosComponent } from '@app/pages/relatorios/faturamento/faturamento-recebidos/faturamento-recebidos.component';
import { RelatorioEstadosProcessoComponent } from '@app/pages/relatorios/estados-processo/estados-processo.component';
import { PagasPagarComponent } from '@app/pages/relatorios/pagas-pagar/pagas-pagar.component';
import { PagasPagarRestritoComponent } from './pagas-pagar-restrito/pagas-pagar-restrito.component';
import { ReceberRecebidasComponent } from '@app/pages/relatorios/receber-recebidas/receber-recebidas.component';
import { ReactiveFormsModule } from '@angular/forms';

// Services
import { RelatorioService } from '@app/services/relatorio.service';
import { ConsultarAnexosComponent } from './consultar-anexos/consultar-anexos.component';
//import { PorNaturezaDeAcaoComponent } from './relatorio-processos-filtrados/por-natureza-de-acao/por-natureza-de-acao-depreciado.component';
import { FaturamentoPorTipoAcaoComponent } from './faturamento/faturamento-por-tipo-acao/faturamento-por-tipo-acao.component';
//import { FiltradoPorAdvogadoComponent } from './relatorio-processos-filtrados/por-advogado/filtrado-por-advogado.component';
import { RelatorioNotaFiscalComponent } from './nota-fiscal/relatorio-nota-fiscal.component';
import { RpvPrecatorioComponent } from './rpv-precatorio/rpv-precatorio.component';
import { RpvRelatorioComponent } from './rpv-precatorio/rpv-relatorio/rpv-relatorio.component';
import { PrecatorioRelatorioComponent } from './rpv-precatorio/precatorio-relatorio/precatorio-relatorio.component';
import { AcordoTrabalhistaComponent } from './acordo-trabalhista/acordo-trabalhista.component';
import { FluxoDeCaixaDiarioRealComponent } from './fluxo-de-caixa-diario/fluxo-de-caixa-diario-real/fluxo-de-caixa-diario-real.component';
import { FluxoDeCaixaDiarioPrevisaoComponent } from './fluxo-de-caixa-diario/fluxo-de-caixa-diario-previsao/fluxo-de-caixa-diario-previsao.component';

@NgModule({
  declarations: [
    RelatorioExtratoBancarioComponent,
    RelatorioFluxoDeCaixaDiarioComponent,
    RelatorioDRComponent,
    DrFilhoComponent,
    RelatorioDRPorTipoComponent,
    RelatorioLogsComponent,
    RelatorioExtratoParticipanteComponent,
    RelatorioCustosProcessoComponent,
    RecebimentosAtrasadosComponent,
    RelatorioChequeComponent,
    RelatorioPrevisaoMovimentacaoComponent,
    RelatoriosMeAviseComponent,
    RelatorioProtocolosDiariosComponent,
    ProtocolosTipoComponent,
    RelatorioPublicacoesDiariasComponent,
    PublicacoesTipoComponent,
    RelatorioEstadosProcessoComponent,
    RelatoriosClientesComponent,
    RelatorioProcessosFiltradosComponent,
    FaturamentoComponent,
    ClientesPorAdvogadoComponent,
    ClientesSemMovimentacaoComponent,
    ClientesFiltrosComponent,
    // FiltradoPorAreaDoProcessoComponent,
    // FiltradoPorCidadeComponent,
    // FiltradoPorUnidadeComponent,
    //FiltradoPorAdvogadoComponent,
    FaturamentoPorTipoAcaoComponent,
    FaturamentoRecebidosComponent,
    PagasPagarComponent,
    PagasPagarRestritoComponent,
    ReceberRecebidasComponent,
    ConsultarAnexosComponent,
    //PorNaturezaDeAcaoComponent,
    MetaVisaoMensalComponent,
    MetaVisaoAnualComponent,
    MetaNovosProcessosComponent,
    RelatorioNotaFiscalComponent,
    RpvPrecatorioComponent,
    RpvRelatorioComponent,
    PrecatorioRelatorioComponent,
    AcordoTrabalhistaComponent,
    FluxoDeCaixaDiarioRealComponent,
    FluxoDeCaixaDiarioPrevisaoComponent
  ],
  imports: [
    RelatoriosRoutingModule,
    SharedModule,
    ReactiveFormsModule,

  ],
  providers: [
    // AuthGuard,
    RelatorioService
  ]
})
export class RelatoriosModule { }
